import { gql } from '@apollo/client';
import { Role, ServiceAdminRole } from '~graphql/__generated__/types';
import { useUpdateAdminRolesMutation } from './__generated__/UpdateAdminRoles.graphql';

gql`
  mutation UpdateAdminRoles($input: UserUpdateInput!) {
    userUpdate(input: $input) {
      user {
        id
        roles
        serviceAdminRoles
      }
    }
  }
`;

export type AdminRolesUser = {
  id: string;
  givenName: string;
  familyName: string;
  roles: Role[];
  customerIds?: string[] | null;
};

// Every field except serviceAdminRoles is passed through unchanged from the existing user —
// userUpdate replaces `roles`/`customerIds` wholesale, so omitting them here would reset the
// user's organization roles and widen their customer-scoped access to every customer in the org
// (see validateCustomerIds in MutationUserUpdate.ts).
export function useUpdateAdminRoles() {
  const [mutate, result] = useUpdateAdminRolesMutation();

  const updateAdminRoles = (user: AdminRolesUser, serviceAdminRoles: ServiceAdminRole[]) =>
    mutate({
      variables: {
        input: {
          userId: user.id,
          givenName: user.givenName,
          familyName: user.familyName,
          roles: user.roles,
          customerIds: user.customerIds,
          serviceAdminRoles,
        },
      },
    });

  return [updateAdminRoles, result] as const;
}
